interface ShareProps {
    color?: string;
    width?: number;
    height?: number;
}

const Share = ({color = '#000000', width = 16, height = 16}: ShareProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 16 16"
    >
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 5.333a2 2 0 100-4 2 2 0 000 4zM4 10a2 2 0 100-4 2 2 0 000 4zM12 14.667a2 2 0 100-4 2 2 0 000 4zM5.727 8.94l4.553 2.787M10.273 4.273L5.727 7.06"
        />
    </svg>
);

export default Share;
